/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
export const EP_REACT_PROPS_OBSERVABLE_OBJECT = '__EP_REACT_PROPS_OBSERVABLE_OBJECT__';

/**
 * @deprecated Use `import { ObservableObject } from '@atlassian/embedded-confluence-common/observable-object/ObservableObject'` instead.
 */
export { ObservableObject } from './ObservableObject';
